import { createSelector } from '@reduxjs/toolkit';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'data';
import { ProjectTemplateProjectPhase } from '../types';
import { useActiveTemplateId } from './use-active-project-template';

const getProjectTemplateProjectPhase = () =>
  createSelector(
    (state: RootState) => state.templates.project.data,
    (_, { projectPhaseId, templateId }) => ({
      projectPhaseId,
      templateId,
    }),
    (data, { projectPhaseId, templateId }): ProjectTemplateProjectPhase =>
      data[templateId].projectPhases[projectPhaseId],
  );

export const useProjectTemplateProjectPhase = (
  projectPhaseId: number,
): ProjectTemplateProjectPhase => {
  const templateId = useActiveTemplateId();
  const projectPhaseObject = useMemo(getProjectTemplateProjectPhase, []);

  return useSelector((state: RootState) =>
    projectPhaseObject(state, { projectPhaseId, templateId }),
  );
};
